export type UserProfile = {
  id: string;
  email: string;
  display_name: string;
  avatar_url: string | null;
};

export type ActivityKind = "likes" | "dislikes" | "comments";

export type UserActivityItem = {
  id: string;
  body?: string;
  reaction?: "like" | "dislike";
  created_at: string;
  post: { slug: string; title: string } | null;
};

export type UserActivityPage = {
  items: UserActivityItem[];
  hasMore: boolean;
  page: number;
};

async function accountRequest<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    ...init,
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", ...(init?.headers ?? {}) }
  });
  if (!response.ok) {
    const details = await response.json().catch(() => null) as { error?: string } | null;
    throw new Error(details?.error ?? "Unable to complete the request. Try again.");
  }
  return response.json() as Promise<T>;
}

export function getProfile() {
  return accountRequest<UserProfile>("/api/profile");
}

export function updateProfile(profile: Pick<UserProfile, "display_name" | "avatar_url">) {
  return accountRequest<UserProfile>("/api/profile", { method: "PATCH", body: JSON.stringify(profile) });
}

export function getProfileActivity(kind: ActivityKind, page = 1) {
  const params = new URLSearchParams({ kind, page: String(page) });
  return accountRequest<UserActivityPage>(`/api/profile/activity?${params}`);
}
